<template>
  <DetailsPane
    :title="title || learningPath.name"
    :hide-title="hideTitle"
    :hide-close="hideClose"
    :height="height"
    :auto-height="autoHeight"
    @close="$emit('close')"
  >
    <div class="learning-path-details">
      <LearningPathBanner
        :learningPath="learningPath"
        :enrollment="enrollment"
        contentClass="p-4"
      />
      <LearningPathProgressBar
        v-if="!!enrollment"
        :learningPath="learningPath"
      />
      <LearningPathOverview
        :learningPath="learningPath"
        class="details-pane-table mb-5 py-3 px-4"
      />
    </div>
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
import DetailsPaneMixin from "mixins/DetailsPane";
import LearningPathBanner from "./Banner";
import LearningPathProgressBar from "./ProgressBar";
import LearningPathOverview from "./LearningPathOverview";

export default {
  mixins: [DetailsPaneMixin],
  components: {
    DetailsPane,
    LearningPathBanner,
    LearningPathProgressBar,
    LearningPathOverview,
  },
  props: {
    learningPath: { type: Object, required: true },
    enrollment: { type: Object, default: () => {} },
  },
};
</script>